import {nameofFactory} from 'web-app/util/typescript';

export interface FormData {
    name: string;
    description: string;
    deadline: string;
    recipients: string;
    from: string;
    to: string;
    days: string[];
    askForDetailedAttendance?: boolean;
}

export const fieldName = nameofFactory<FormData>();
